import { Box, Typography } from '@mui/material'
import { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

export function RedHoverLink(props: {
  text: string
  href: string
  hovered: boolean
  onHover: (href: string | false) => void
}) {
  const navigate = useNavigate()
  const isMobile = window.innerWidth < 768

  return (
    <Box
      // Make the container position: relative so the ball can be absolutely positioned inside it
      sx={{
        position: 'relative',
        display: 'inline-flex',
        alignItems: 'center',
        cursor: 'pointer',
        marginBottom: '4px',
      }}
      onMouseEnter={() => props.onHover(props.href)}
      onMouseLeave={() => props.onHover(false)}
      onClick={() => navigate(`/${props.href}/`)}
    >
      <Typography
        variant="subtitle1"
        fontWeight="bold"
        fontSize={isMobile ? 15 : 24}
      >
        {props.text}
      </Typography>

      {props.hovered && (
        <Box
          sx={{
            position: 'absolute',
            // Place it to the right of the text; shift it slightly with left + transform.
            left: 'calc(100% + 3px)',
            // Vertically center it if you want:
            top: '50%',
            transform: 'translateY(-55%)',
            width: '12px',
            height: '12px',
            bgcolor: 'red',
            borderRadius: '50%',
          }}
        />
      )}
    </Box>
  )
}

export function NavBar(props: { direction: 'column' | 'row' }) {
  const currentPath = useLocation().pathname
  const [hoveredLink, setHoveredLink] = useState('')

  const onHover = (hovered: string | false) => {
    setHoveredLink(hovered ? hovered : '')
  }

  return (
    <Box
      sx={
        props.direction === 'row'
          ? {
              display: 'flex',
              flexDirection: props.direction,
              justifyContent: 'flex',
              flexWrap: 'wrap',
              padding: '15px 10px 10px 10px',
            }
          : {}
      }
    >
      <Box sx={{ marginRight: '40px' }}>
        <RedHoverLink
          text="HOME"
          href="home"
          onHover={onHover}
          hovered={
            hoveredLink === 'home' || (!hoveredLink && currentPath === '/home/')
          }
        />
      </Box>
      <Box sx={{ marginRight: '40px' }}>
        <RedHoverLink
          text="SCHEDULE"
          href="schedule"
          onHover={onHover}
          hovered={
            hoveredLink === 'schedule' ||
            (!hoveredLink && currentPath === '/schedule/')
          }
        />
      </Box>
      <Box sx={{ marginRight: '40px' }}>
        <RedHoverLink
          text="TRANSPORT"
          href="travel"
          onHover={onHover}
          hovered={
            hoveredLink === 'travel' ||
            (!hoveredLink && currentPath === '/travel/')
          }
        />
      </Box>
      <Box sx={{ marginRight: '40px' }}>
        <RedHoverLink
          text="ATTIRE"
          href="attire"
          onHover={onHover}
          hovered={
            hoveredLink === 'attire' ||
            (!hoveredLink && currentPath === '/attire/')
          }
        />
      </Box>
      <Box sx={{ marginRight: '40px' }}>
        <RedHoverLink
          text="GUIDE TO CATSKILLS"
          href="guide"
          onHover={onHover}
          hovered={
            hoveredLink === 'guide' ||
            (!hoveredLink && currentPath === '/guide/')
          }
        />
      </Box>
      <Box sx={{ marginRight: '40px' }}>
        <RedHoverLink
          text="MAR2019"
          href="2019"
          onHover={onHover}
          hovered={
            hoveredLink === '2019' || (!hoveredLink && currentPath === '/2019/')
          }
        />
      </Box>
      <Box sx={{ marginRight: '40px' }}>
        <RedHoverLink
          text="SEP2025"
          href="2025"
          onHover={onHover}
          hovered={
            hoveredLink === '2025' || (!hoveredLink && currentPath === '/2025/')
          }
        />
      </Box>
      <Box sx={{ marginRight: '40px' }}>
        <RedHoverLink
          text="REGISTRY"
          href="registry"
          onHover={onHover}
          hovered={
            hoveredLink === 'registry' ||
            (!hoveredLink && currentPath === '/registry/')
          }
        />
      </Box>
      <Box sx={{ marginRight: '40px' }}>
        <RedHoverLink
          text="STICKERS"
          href="stickers"
          onHover={onHover}
          hovered={
            hoveredLink === 'stickers' ||
            (!hoveredLink && currentPath === '/stickers/')
          }
        />
      </Box>
    </Box>
  )
}
